// Physical (PBR) profiles per material family. Drives the 3D metalness/roughness so
// non-jewelry products (plastic, wood, fabric, stainless steel) render realistically
// instead of defaulting to a shiny metallic look (a shirt in gold looked weird).
export const MATERIAL_FAMILIES = {
  metal:   { key: "metal",   label: "Metal (joyería)", metalness: 0.9, roughness: 0.28, market: true },
  steel:   { key: "steel",   label: "Stainless Steel", metalness: 1.0, roughness: 0.35, market: false },
  plastic: { key: "plastic", label: "Plástico",        metalness: 0.0, roughness: 0.45, market: false },
  wood:    { key: "wood",    label: "Madera",          metalness: 0.0, roughness: 0.8,  market: false },
  fabric:  { key: "fabric",  label: "Tela",            metalness: 0.0, roughness: 0.95, market: false },
};

export const FAMILY_ORDER = ["metal", "steel", "plastic", "wood", "fabric"];

const JEWELRY_METALS = [
  { id: "silver", name: "Plata", hex: "#C0C0C0" },
  { id: "gold10ky", name: "Oro 10K Amarillo", hex: "#D4AF37" },
  { id: "gold14ky", name: "Oro 14K Amarillo", hex: "#D4AF37" },
  { id: "gold18ky", name: "Oro 18K Amarillo", hex: "#CFA227" },
  { id: "gold24ky", name: "Oro 24K Amarillo", hex: "#E6BE22" },
  { id: "gold10kw", name: "Oro 10K Blanco", hex: "#E8E8E8" },
  { id: "gold14kw", name: "Oro 14K Blanco", hex: "#E8E8E8" },
  { id: "gold18kw", name: "Oro 18K Blanco", hex: "#EDEDED" },
  { id: "gold24kw", name: "Oro 24K Blanco", hex: "#F0F0F0" },
  { id: "gold10kr", name: "Oro 10K Rosa", hex: "#B76E79" },
  { id: "gold14kr", name: "Oro 14K Rosa", hex: "#C08081" },
  { id: "gold18kr", name: "Oro 18K Rosa", hex: "#C98A8A" },
  { id: "gold24kr", name: "Oro 24K Rosa", hex: "#D89A9A" },
  { id: "platinum", name: "Platino", hex: "#E5E4E2" },
];

// Owner-selectable color/finish presets per family (customer picks one).
export const MATERIAL_PRESETS = {
  metal: JEWELRY_METALS,
  steel: [
    { id: "steel_polished", name: "Acero pulido", hex: "#C7CBCE" },
    { id: "steel_brushed", name: "Acero cepillado", hex: "#AEB2B5" },
    { id: "steel_black", name: "Acero negro", hex: "#3A3D40" },
  ],
  plastic: [
    { id: "plastic_black", name: "Plástico negro", hex: "#1E1E1E" },
    { id: "plastic_white", name: "Plástico blanco", hex: "#F0F0F0" },
    { id: "plastic_red", name: "Plástico rojo", hex: "#C0392B" },
    { id: "plastic_blue", name: "Plástico azul", hex: "#2E5FA3" },
    { id: "plastic_green", name: "Plástico verde", hex: "#2E8B57" },
    { id: "plastic_yellow", name: "Plástico amarillo", hex: "#E0B93B" },
  ],
  wood: [
    { id: "wood_oak", name: "Roble", hex: "#C8A063" },
    { id: "wood_walnut", name: "Nogal", hex: "#5A3A22" },
    { id: "wood_mahogany", name: "Caoba", hex: "#6E2C1E" },
    { id: "wood_pine", name: "Pino", hex: "#DEB887" },
    { id: "wood_ebony", name: "Ébano", hex: "#2B2320" },
  ],
  fabric: [
    { id: "fabric_white", name: "Tela blanca", hex: "#ECECEC" },
    { id: "fabric_black", name: "Tela negra", hex: "#232323" },
    { id: "fabric_navy", name: "Tela azul marino", hex: "#26324D" },
    { id: "fabric_red", name: "Tela roja", hex: "#8E2B2B" },
    { id: "fabric_gray", name: "Tela gris", hex: "#7A7E82" },
    { id: "fabric_beige", name: "Tela beige", hex: "#C9B594" },
  ],
};

// Default material family suggested when the owner picks a product class.
export const CLASS_DEFAULT_FAMILY = {
  joyeria: "metal",
  ropa: "fabric",
  ilustracion: "plastic",
  modelo3d: "plastic",
  mueble: "wood",
  accesorio: "plastic",
  otro: "plastic",
};

export function familyProps(fam) {
  return MATERIAL_FAMILIES[fam] || MATERIAL_FAMILIES.metal;
}

// Sensible size defaults per material family: discrete options + a measurement unit.
// clothing = letter sizes, jewelry = ring numbers, 3D/plastic = mm, wood/steel = cm.
export const FAMILY_SIZE = {
  metal:   { options: ["5", "6", "7", "8", "9", "10", "11", "12"], unit: "" },
  steel:   { options: [], unit: "cm" },
  plastic: { options: [], unit: "mm" },
  wood:    { options: [], unit: "cm" },
  fabric:  { options: ["XS", "S", "M", "L", "XL", "XXL"], unit: "" },
};

// Measurement unit options the owner can pick for a product's size.
export const SIZE_UNITS = [
  { key: "", label: "Sin unidad (talla/número)" },
  { key: "mm", label: "Milímetros (mm)" },
  { key: "cm", label: "Centímetros (cm)" },
  { key: "in", label: "Pulgadas (in)" },
  { key: "ft", label: "Pies (ft)" },
  { key: "m", label: "Metros (m)" },
];

